<template>
  <div>
    <!-- <div v-if="selectSub"> -->
    <el-carousel trigger="click" ref="carousel" arrow="never" :autoplay='autop'>
      <el-carousel-item>
        <el-form size="mini" label-width="120px" class="tableform" style="margin-top:40px">
          <div class="block" style=" margin: 20px 10%;">
            <!-- style="text-align: center;" -->
            <span class="demonstration" style=" margin-right: 10px">{{ $t("message.table.type") }}</span>
            <el-cascader style=" width:65% ; " size="small" v-model="value" :options="options"
              :props="{ expandTrigger: 'hover' }" @change="getCreateData" clearable></el-cascader>

          </div>

          <el-row style="margin-top:140px">
            <el-col :offset="16" :span="4">
              <el-button size="mini" type="primary" style=" margin-right: 10px" @click="cancel">
                <!-- <el-button size="mini" type="primary" @click="next" v-if="this.baseClass===106"> -->
                {{ $t("message.button.cancel") }}
              </el-button>
            </el-col>
          </el-row>

        </el-form>
      </el-carousel-item>
      <el-carousel-item>
        <!-- <iForm ref='formData'  :pageFirst="page_one" :pageSecond="page_two" :pageThird="page_three" ></iForm> -->
        <!-- <iForm ref='form' :typeId='ee' :Name='typeName'  :ops='searchList' @submitData="submit"  @toNext='newMf'>
          <el-button @click="cancel">{{$t('message.button.cancel')}}</el-button>
        </iForm> -->

        <el-form size="mini" ref="form" label-width="200px" v-if="createForm" style="align:center;overflow-y: auto;"
          :style="{ height: this.$refs.carousel.$el.clientHeight - 20 + 'px' }">

          <div v-if="baseClass == 301">
            <div v-for="(item, index) in pageInfo" :key="index">
              <!-- <PageList :page="item.column" :pageId="pageId" :change.sync="item.val" :reset="resetNum" @MFValue="getMF"> -->
              <ProjectCreate :page="item.column" :pageId="pageId" :change.sync="item.value" :reset="resetNum"
                :checkReq.sync="item.req">
              </ProjectCreate>
            </div>

          </div>
          <div v-else>
            <div v-for="(item, index) in pageInfo" :key="index">
              <!-- <PageList :page="item.column" :pageId="pageId" :change.sync="item.val" :reset="resetNum" @MFValue="getMF"> -->
              <PageList :page="item.column" :pageId="pageId" :change.sync="item.value" :reset="resetNum"
                @MFValue="getMF" :checkReq.sync="item.req">
              </PageList>
            </div>
            <div v-if="creatBy == 'BOM'">
              <el-form-item label="数量" required>
                <el-input v-model="quantity" style="width:50%"></el-input>
              </el-form-item>
              <el-form-item label="生产单位" required v-if='systemName.indexOf("奥斯汀") != -1'>
                <el-select v-model="department" :placeholder="$t('message.placeholder.select')" style="width:50%"
                  multiple>
                  <el-option :label="items.label" :value="items.value" v-for="items in departmentList"
                    :key="items.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>

          <el-form-item>
            <el-button type="primary" @click="submitForm">{{
              $t("message.button.createNow")
            }}</el-button>
            <el-button @click="reset">{{ $t("message.button.reset") }}</el-button>
            <el-button @click="cancel" type="success">{{ $t("message.button.cancel") }}</el-button>
          </el-form-item>
        </el-form>
      </el-carousel-item>
      <el-carousel-item>
        <!-- <iForm ref='formData'  :pageFirst="page_one" :pageSecond="page_two" :pageThird="page_three" ></iForm> -->

        <!-- <CreateMf  v-if="search"  @getMFid='addList'  >
          <el-button @click="cancel">{{$t('message.button.cancel')}}</el-button>
        </CreateMf> -->
        <!-- <SearchMf v-else @listDbClick="addList"></SearchMf> -->
      </el-carousel-item>

    </el-carousel>

  </div>

</template>

<script>
// import Form from "./form"
import axios from "axios";
import PageList from "./pageList.vue";

import ProjectCreate from "@/views/create/common/projectCreate.vue";

export default {
  data() {
    return {
      manufacturerId: "",
      // selectSub:true,
      options: [],
      value: "",
      pageInfo: {},
      resetNum: 0,
      autop: false,
      createForm: false,
      ee: "",
      pageId: "",
      typeName: "",
      // arr: [],
      search: Boolean,
      searchList: [],
      classList: [],
      classId: "",
      quantity: '',
      department: [],
      systemName: '',
      saveUrl: [
        { id: 101, url: "/pmdm/items/saveItemP1P2P3" },
        { id: 104, url: "/pmdm/changes/saveChangeP1P2P3" },
        { id: 105, url: "/pmdm/manufacturers/saveManufacturerP1P2P3" },
        { id: 106, url: "/pmdm/manufacturerPart/saveManufacturerPartP1P2P3" },
        { id: 301, url: "/ppm/project/saveProject" },
        { id: 401, url: "/pqm/quality/saveQualityP1P2P3" },
        { id: 501, url: "/pmdm/technology/saveTechnologyP1P2P3" },
        { id: 502, url: "/pmdm/resource/saveResourceP1P2P3" },
      ],
    };
  },
  props: ["baseClass", 'classIdAndSubClassId', 'creatBy', 'departmentList'],
  components: { PageList, ProjectCreate },
  // components: { PageList, SearchMf, CreateMf},
  mounted() {
    // this.getCreateData()
    this.getSubClass();
  },
  created() {
    this.systemName = window.sessionStorage.getItem("systemName");
  },
  methods: {

    getMF(e) {
      this.manufacturerId = e;
    },

    addList(row) {
      //添加
      this.searchList = row;
      this.$refs.carousel.prev();
    },
    newMf(e) {
      this.$refs.carousel.next();
      if (e == 0) {
        this.search = true;
      } else {
        this.search = false;
      }
    },
    cancel() {
      // this.$refs.carousel.prev();
      this.$emit("closeCreateNew", "");
      this.pageInfo = {};
    },
    submitForm() {

      const req = this.pageInfo.map(i => i.req);
      let m = this.pageInfo.map((i) => i.value);

      for (const key in req) {
        if (((!this.quantity && this.creatBy == 'BOM')) || (!req[key] && req[key] != undefined)) {
          this.$message.error(this.$t('message.warning.required'))
          return
        }
      }
      if (this.creatBy == 'BOM' && this.systemName.indexOf("奥斯汀") != -1) {
        if (!this.department.join(';')) {
          this.$message.error(this.$t('message.warning.required'))
          return
        }
      }

      let obj = {};
      obj.pageOne = Object.assign(m[0], { classId: this.pageId.clsId });
      obj.pageTwo = m[1];
      obj.pageThree = m[2];


      if (this.manufacturerId) {
        Object.assign(obj.pageOne, { manufacturerId: this.manufacturerId });
      }

      if (this.baseClass == 301) {
        Object.assign(obj.pageOne, { parentId: 0, rootId: 0 });
      }

      obj.objectId = {
        classId: this.pageId.clsId,
        subClassId: this.pageId.id,
        id: "",
      };
      const n = parseInt((this.pageId.clsId + '').substr(0, 3));
      const url = this.saveUrl.find(i => i.id == n).url
      this.submit(obj, url);
    },

    submit(obj, url) {

      axios.post(url, obj).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: "success",
          });
          let obj = {
            itemClassId: res.data.object.classId,
            itemId: res.data.object.id,
            itemSubClassId: res.data.object.subclassId,
            0: res.data.object.name,
          };
          // this.getRouteLink(obj);
          let object = {
            id: obj.itemId,
            itemId: obj.itemId,
            itemSubClassId: obj.itemSubClassId,
            itemClass: obj.itemClassId,
            quantity: this.quantity,
            department: this.department,
            itemNumber: obj[0],
          };
          if (this.baseClass == 106) {
            object = Object.assign(object, {
              manufacturerId: this.manufacturerId,
            });
          }
          this.$emit("addToList", [object]);
          //已完成的变更单新建变更后把当前的受影响物件添加到新变更单去
          this.$emit("addToAffectedItem", [object]);
        }
      });
    },
    reset() {
      this.resetNum++;
    },
    getSubClass() {
      axios
        .get("/pmdm/admin/cls/getClsesWithSubClses?baseClsId=" + this.baseClass)
        .then((res) => {
          if (this.creatBy == 'createQuality' || this.creatBy == 'createTechnologyChange') {
            let arr = res.data.object.clses;
            for (let i = 0; i < arr.length; i++) {
              const e = arr[i];
              if (e.id == 40102 || e.id == 10410) {
                this.classList = this.classList.concat(e.children);
                let a = e.children.map((item) => {
                  return { value: item.id, label: item.name };
                });
                this.options.push({ value: e.id, label: e.name, children: a });
              }
            }
          } else {
            let arr = res.data.object.clses;

            for (let i = 0; i < arr.length; i++) {
              const e = arr[i];
              if (e.id !== -2) {  // 暂时不提供通过xml快速创建项目及通过模板创建项目;
                this.classList = this.classList.concat(e.children);
                let a = e.children.map((item) => {
                  return { value: item.id, label: item.name };
                });
                this.options.push({ value: e.id, label: e.name, children: a });
              }
            }
          }

          if (this.classIdAndSubClassId) {
            let w = this.classIdAndSubClassId;
            this.getCreateData(w);
          }
        });
    },
    async chooseClick(e) {
      this.pageId = e;
      this.typeName = e.name;
      this.createForm = true;

    },

    getlfcircle() {
      const obj = { url: '/pmdm/admin/lifecycle/getLifecyclePhaseByClass', id: 106, query: { clsId: 10501 }, columnId: 1012003 };
      return axios.get(`${obj.url + this.params(obj.query)}`)
    },

    getDataList(arr) {

      if (arr.length === 3) {
        const tablistList = [...arr]
        return { tablistList }
      }
      const [lifeCircleRes, ...abc] = arr
      return { lifeCircleRes, tablistList: [...abc] }
    },

    async getCreateData(w) {
      const e = w[w.length - 1];
      if (e) this.$refs.carousel.next();
      this.createForm = true;
      this.ee = e;
      this.pageId = this.classList.filter((i) => {
        return i.id == e;
      })[0];
      this.typeName = this.pageId.name;
      this.classId = this.pageId.clsId;

      const arr = [1, 2, 3].map(i => axios.get(`/pmdm/admin/getVisibleTableColumnInfo/${e}/${i}`));

      const list = this.baseClass == 106 ? [this.getlfcircle(), ...arr] : [...arr];
      // const
      Promise.all(list).then(res => {
        let arr = [];
        const { lifeCircleRes = '', tablistList } = this.getDataList(res);
        const lifeCircleListEntry = {};
        if (lifeCircleRes) {
          lifeCircleRes.data.object.phases.map(i => {
            const { id, phaseName } = i
            lifeCircleListEntry[id] = phaseName
          });
        }

        this.pageInfo = tablistList.map((i, e) => {
          const column = i.data.object.columnInfo;
          const { listEntries, listIds, ids, listTypes } = column;
          const index = ids.indexOf(1012003);
          listEntries['99'] = lifeCircleListEntry;
          index !== -1 && (listIds[index] = 99);
          listTypes[index] = 9

          return { column: i.data, value: {} }
        })
      })
    },
  },
};
</script>

<style scoped>
.tableForm {
  margin: auto;
  min-height: 210px;
}

;

.demonstration {
  margin: 0px 0px 0px 10px;
  border: 20px;
}
</style>